// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Sidebar_modalOverlay__AoGX2","modal-fade":"Sidebar_modal-fade__LmYHb","modal":"Sidebar_modal__Jooxd","modal-slide":"Sidebar_modal-slide__IvVdM"};